module.exports = __webpack_public_path__ + "static/media/dropdown-chevron.5203b704.svg";